import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "event-evolution",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Track how event detections and responses evolve.",
    domain: "events",
    visual: "Line chart",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart", skeletonMinHeight: "26rem" },
  defaultLayoutClassName: "col-span-12",
};
